import 'jquery-match-height';

import Navigation from '../components/navigation/navigation.js';
import SharingIcon from '../components/sharing/sharing.js';
import Sliders from '../components/sliders.js';
import ProductNav from '../components/productNav.js';
import OfferBanner from '../components/offerBanner.js';
import NewsletterSignup from '../components/newsletterSignup.js';
import StockNotifications from '../components/stockNotifications.js';
import OfferPopup from '../components/popup/offerPopup.js';
import PostcodeLookup from '../components/postcodeLookup.js';

export default {
  init() {

    // JavaScript to be fired on all pages
    jQuery(document).ready(function($){

      let $shareIcons = $('.share');
      if( $shareIcons.length > 0 )
        $shareIcons.each((i, item) => {
          new SharingIcon(item);
        });
      // Add placeholder to footer newsletter form
      let $footerTop = $('.footer-top');
      $footerTop.find('input[type="text"]').attr('placeholder', 'Sign up to our newsletter');
      $footerTop.find('br').remove();

      // force horrible coupon message styling
      $('.js-20yt-coupon-applied-error').closest('ul').removeClass('woocommerce-error').addClass('woocommerce-message');

      // initialise navigation functionality
      Navigation.init();

      Sliders.init();

      ProductNav.init();

      OfferBanner.init();

      NewsletterSignup.init();
      
      StockNotifications.init();

      // initialise offer popup functionality
      OfferPopup.init();

      PostcodeLookup.init();
    })

  },
  finalize() {

    // related products slider
    $('.related.products .products').slick({
      dots: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      responsive: {
        breakpoint: 1300,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1
        }
      }
    });
    
    // $('select').select2();

    $('.products .product-card').matchHeight({ byRow: true });
    $('.review-card__bottom').matchHeight();
    $('.number-icon-steps__steps img').matchHeight();
    $('.number-icon-steps__steps span').matchHeight();
    $('.number-icon-steps__steps p').matchHeight();
    $('.wp-block-columns .wp-block-column').matchHeight();
    $('.review-carousel__items__item').matchHeight();

    if (window.location.href.indexOf("health-tests") > -1) {
      var cat = 'health-tests';
      $(".products .table-row, .products .table-row .product-card").each(function () {
        $(this).removeClass("active");
      });

      $(".archive-tabs .tab").each(function () {
        var tabCat = $(this).data("cat");
        if(tabCat == cat){
          $(this).addClass("active");
        } else {
          $(this).removeClass("active");
        }
      });

      $(".products .table-row."+cat).addClass("active");
      $(".products .table-row .product-card."+cat).addClass("active");
    } else if(window.location.href.indexOf("food-intolerance-tests") > -1){
      var cat = 'food-intolerance-tests';
      $(".products .table-row, .products .table-row .product-card").each(function () {
        $(this).removeClass("active");
      });

      $(".archive-tabs .tab").each(function () {
        var tabCat = $(this).data("cat");
        if(tabCat == cat){
          $(this).addClass("active");
        } else {
          $(this).removeClass("active");
        }
      });

      $(".products .table-row."+cat).addClass("active");
      $(".products .table-row .product-card."+cat).addClass("active");
    } else if(window.location.href.indexOf("supplements") > -1){
      var cat = 'supplements';
      $(".products .table-row, .products .table-row .product-card").each(function () {
        $(this).removeClass("active");
      });

      $(".archive-tabs .tab").each(function () {
        var tabCat = $(this).data("cat");
        if(tabCat == cat){
          $(this).addClass("active");
        } else {
          $(this).removeClass("active");
        }
      });

      $(".products .table-row."+cat).addClass("active");
      $(".products .table-row .product-card."+cat).addClass("active");
    }

    $(".archive-tabs .tab").click(function () {
      // on click of a tab get the category data from this tab
      var cat = $(this).data("cat");

      // remove the active class from all tabs
      $(".archive-tabs .tab").each(function () {
        $(this).removeClass("active");
      });

      // re-add active class to the current tab for border bottom
      $(this).addClass('active');

      // hide every row and every product
      $(".products .table-row, .products .table-row .product-card").each(function () {
        $(this).removeClass("active");
      });

      // if the tab equals all tests show everything
      if(cat == 'all-tests'){
        $(".products .table-row").addClass("active");
        $(".products .table-row .product-card").addClass("active");
      } else {
        // else only show the current category and products within this
        $(".products .table-row."+cat).addClass("active");
        $(".products .table-row .product-card."+cat).addClass("active");
      }

      var url = window.location.href.split('?')[0];
      history.pushState({step : 2}, null, url + '?category='+cat);
    });
    
  },
};
